export default {
  title: "About Us",
  mission_vision: "Mission and Vision",
  mission_vision_desc:
    "Our mission is to help SMEs quickly achieve EU CBAM compliance with over 90% accuracy, reducing costs and improving efficiency, while supporting the 2026 sustainability goals.",
  team: "Team Introduction",
  team_desc:
    "TaxEcoBit is a CBAM compliance SaaS platform built by professionals, dedicated to providing SMEs with efficient and reliable tools to simplify compliance processes and continuously update to meet EU regulatory requirements.",
  contact: "Contact Us",
  contact_email: "Email: {email}",
  follow_us: "Follow us:",
  newsletter: "Newsletter",
  newsletter_desc:
    "Subscribe to our newsletter to get the latest CBAM policy interpretation, compliance tips, and feature updates.",
  newsletter_button: "Subscribe",
  agreement_text:
    "I agree to use this email to receive the latest CBAM policy interpretation, compliance tips, and feature updates, and agree to process my personal data according to GDPR requirements.",
  support: "Instant Support",
  support_desc:
    "We have compiled FAQs for your quick self-service inquiry; if you need further assistance, you can submit a ticket at any time, and our support team will respond within 24-48 hours.",
  support_button: "Contact Support",
  chat_opened: "Support window opened",
  newsletter_success: "Subscription successful: {email}",
};
